<script lang="ts" setup>
import { NConfigProvider } from 'naive-ui'
import { zhCN, dateZhCN } from 'naive-ui'
import { theme } from '~~/theme'
const props = defineProps<{
  bgColor?: string
  fullwidth?: boolean
  nofooter?: boolean
}>()

const widescreen = useState<boolean>('player_widescreen')
const maxWidth = props.fullwidth ? 'min(1920px, max(1000px, 180vh))' : '1000px'
</script>

<template>
  <div
    class="m-layout"
    :style="{
      backgroundColor: bgColor || 'unset'
    }"
  >
    <TopBar />
    <div
      class="m-layout-page"
      :class="{
        fullwidth
      }"
      :style="{
        width: widescreen ? 'min(80%, 140vh)' : '85%',
        maxWidth: maxWidth
      }"
    >
      <slot />
    </div>
    <MOpenAPP />
    <MFooter v-if="!nofooter" />
  </div>
</template>

<style lang="scss" scoped>
@media screen and (min-width: 600px) {
  .m-layout {
    padding-top: 72px;
    min-height: calc(100vh - 500px);
    &-page {
      padding-top: 20px;
      position: relative;
      margin: 0 auto;
      min-width: 460px;
    }
    .fullwidth {
      padding-top: 0;
    }
  }
}

@media screen and (max-width: 600px) {
  .m-layout {
    padding-top: 72px;
    &-page {
      //padding-top: 16px;
      width: 100% !important;
      min-width: 0px;
    }
  }
}
</style>
